import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteWhatsAppChat } from 'services/whatsAppMessaging';

export const ThunkDeleteWhatsAppChat = createAsyncThunk<undefined, string, { rejectValue: Error }>(
  'whatsAppMessaging/deleteChat',
  async (chatId, { rejectWithValue }) => {
    try {
      await deleteWhatsAppChat(chatId);
    } catch (error) {
      const { data } = error as { data: Error };
      return rejectWithValue(data);
    }
  },
);
